import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { buildHttpParams } from '../../shared/utils/query.utils';
import { ApiEmptyResponseDto, ApiPaginatedResponseDto, ApiResponseDto } from '../common-dtos';
import { FileDto } from './dtos/file.dto';
import { FileStorageArchiveFilesRequestDto } from './dtos/file-storage-archive-files.request.dto';
import { FileStorageFindFilesRequestDto } from './dtos/file-storage-find-files.request.dto';
import { FileStorageGetFileUrlsRequestDto } from './dtos/file-storage-get-file-urls.request.dto';
import { FileStorageUploadRequestDto } from './dtos/file-storage-upload.request.dto';

@Injectable({ providedIn: 'root' })
export class FileStorageApiService {
  constructor(private readonly http: HttpClient) {}

  public uploadVideo(request: FileStorageUploadRequestDto): Observable<ApiEmptyResponseDto> {
    const formData = new FormData();
    formData.set('file', request.file, request.filename);
    formData.set('deviceId', request.deviceId);
    formData.set('date', request.date.toISOString());

    return this.http.post<ApiEmptyResponseDto>('/v1/file-storage/upload/video', formData);
  }

  public uploadPhoto(request: FileStorageUploadRequestDto): Observable<ApiEmptyResponseDto> {
    const formData = new FormData();
    formData.set('file', request.file, request.filename);
    formData.set('deviceId', request.deviceId);
    formData.set('date', request.date.toISOString());

    return this.http.post<ApiEmptyResponseDto>('/v1/file-storage/upload/photo', formData);
  }

  public findFiles(request: FileStorageFindFilesRequestDto): Observable<ApiPaginatedResponseDto<FileDto>> {
    return this.http
      .get<ApiResponseDto<ApiPaginatedResponseDto<FileDto>>>('/v1/file-storage/files', {
        params: buildHttpParams(request),
      })
      .pipe(map((response) => response.data));
  }

  public getFileUrls(request: FileStorageGetFileUrlsRequestDto): Observable<FileDto[]> {
    return this.http
      .get<ApiResponseDto<FileDto[]>>('/v1/file-storage/file-urls', {
        params: buildHttpParams(request),
      })
      .pipe(map((response) => response.data));
  }

  public archiveFiles(request: FileStorageArchiveFilesRequestDto): Observable<unknown> {
    return this.http.delete('/v1/file-storage/files', { params: buildHttpParams(request) });
  }
}
